export const SEARCH_RECIPIENT_START = 'SEARCH_RECIPIENT_START';
export const SEARCH_RECIPIENT_SUCCESS = 'SEARCH_RECIPIENT_SUCCESS';
export const SEARCH_RECIPIENT_FAIL = 'SEARCH_RECIPIENT_FAIL';

export const SEARCH_RECIPIENT_GET_ALL = 'SEARCH_RECIPIENT_GET_ALL';
export const SEARCH_RECIPIENT_GET_ALL_START = `${SEARCH_RECIPIENT_GET_ALL}_START`;
export const SEARCH_RECIPIENT_GET_ALL_SUCCESS = `${SEARCH_RECIPIENT_GET_ALL}_SUCCESS`;
export const SEARCH_RECIPIENT_GET_ALL_FAIL = `${SEARCH_RECIPIENT_GET_ALL}_FAIL`;

export const SEARCH_RECIPIENT_EXPAND_RECIPIENT =
  'SEARCH_RECIPIENT_EXPAND_RECIPIENT';
export const SEARCH_RECIPIENT_EXPAND_RECIPIENT_START = `${SEARCH_RECIPIENT_EXPAND_RECIPIENT}_START`;
export const SEARCH_RECIPIENT_EXPAND_RECIPIENT_SUCCESS = `${SEARCH_RECIPIENT_EXPAND_RECIPIENT}_SUCCESS`;
export const SEARCH_RECIPIENT_EXPAND_RECIPIENT_FAIL = `${SEARCH_RECIPIENT_EXPAND_RECIPIENT}_FAIL`;

export const SEARCH_RECIPIENT_COUNT_PEOPLE = 'SEARCH_RECIPIENT_COUNT_PEOPLE';
export const SEARCH_RECIPIENT_COUNT_PEOPLE_START = `${SEARCH_RECIPIENT_COUNT_PEOPLE}_START`;
export const SEARCH_RECIPIENT_COUNT_PEOPLE_SUCCESS = `${SEARCH_RECIPIENT_COUNT_PEOPLE}_SUCCESS`;
export const SEARCH_RECIPIENT_COUNT_PEOPLE_FAIL = `${SEARCH_RECIPIENT_COUNT_PEOPLE}_FAIL`;

export const SEARCH_PEOPLE_START = 'SEARCH_PEOPLE_START';
export const SEARCH_PEOPLE_SUCCESS = 'SEARCH_PEOPLE_SUCCESS';
export const SEARCH_PEOPLE_FAIL = 'SEARCH_PEOPLE_FAIL';

export const SEARCH_GROUPS = 'SEARCH_GROUPS';
export const SEARCH_GROUPS_START = `${SEARCH_GROUPS}_START`;
export const SEARCH_GROUPS_SUCCESS = `${SEARCH_GROUPS}_SUCCESS`;
export const SEARCH_GROUPS_FAIL = `${SEARCH_GROUPS}_FAIL`;

export const SEARCH_RECIPIENT_SET_RECIPIENT_TYPE =
  'SEARCH_RECIPIENT_SET_RECIPIENT_TYPE';

export const SEARCH_RECIPIENT_SET_SEARCH_TYPE =
  'SEARCH_RECIPIENT_SET_SEARCH_TYPE';

export const SEARCH_RECIPIENT_SET_SELECTED_RECIPIENT_LIST =
  'SEARCH_RECIPIENT_SET_SELECTED_RECIPIENT_LIST';

export const SEARCH_RECIPIENT_SET_FLIP_PANELS =
  'SEARCH_RECIPIENT_SET_FLIP_PANELS';

export const RESET_RECIPIENT_SEARCH_RESULTS = 'RESET_RECIPIENT_SEARCH_RESULTS';

export const RESET_RECIPIENT_SEARCH_STATE = 'RESET_RECIPIENT_SEARCH_STATE';

export const SEARCH_RECIPIENT_SET_EXCLUDED_RECIPIENT_LIST =
  'SEARCH_RECIPIENT_SET_EXCLUDED_RECIPIENT_LIST';

export const INITIALIZE = 'RECIPIENT_SEARCH_INITIALIZE';

export const SEARCH_RECIPIENT_BATCH_SIZE = 20;
export const SEARCH_RECIPIENT_BATCH_LIMIT = 40;
export const MINIMUM_SEARCH_TERM = 2;
